import type { WorkScheduleDayEntry } from '@functieloonhuis/shared';
import { DAY_LABELS, getDayEntryForDay, WORKWEEK_DAYS } from '../utils/weekUtils';
import { ScheduleDayCell } from './ScheduleDayCell';

interface WeekScheduleGridProps {
  entries: WorkScheduleDayEntry[];
}

export function WeekScheduleGrid({ entries }: WeekScheduleGridProps) {
  return (
    <div role="grid" aria-label="Weekrooster" className="w-full">
      {/* Header row */}
      <div className="grid grid-cols-5 gap-2 mb-2" role="row">
        {WORKWEEK_DAYS.map(day => (
          <div
            key={day}
            className="text-center text-sm font-medium text-gray-600 py-1"
            role="columnheader"
          >
            {DAY_LABELS[day]}
          </div>
        ))}
      </div>

      {/* Day cells */}
      <div className="grid grid-cols-5 gap-2" role="row">
        {WORKWEEK_DAYS.map(day => (
          <ScheduleDayCell
            key={day}
            entry={getDayEntryForDay(entries, day)}
            dayOfWeek={day}
          />
        ))}
      </div>
    </div>
  );
}
